import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { PaymentMethodInfo } from '../../types/generated/Account.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdatePaymentCardMutationVariables = Types.Exact<{
  input: Types.UpdatePaymentCardInput;
}>;


export type UpdatePaymentCardMutation = { __typename?: 'Mutation', updatePaymentCard?: { __typename?: 'UpdatePaymentCardPayload', paymentMethod: { __typename: 'PaymentCard', preferredLocale?: Types.SupportedLocale | null, taxId?: string | null, taxType?: string | null, card?: { __typename?: 'CardInfo', brand: string, expMonth: number, expYear: number, last4: string, name?: string | null } | null, billingAddress?: { __typename?: 'BillingAddress', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null } | null } } | null };


export const UpdatePaymentCard = /*#__PURE__*/ gql`
    mutation UpdatePaymentCard($input: UpdatePaymentCardInput!) {
  updatePaymentCard(input: $input) {
    paymentMethod {
      ...PaymentMethodInfo
    }
  }
}
    ${PaymentMethodInfo}` as unknown as DocumentNode<UpdatePaymentCardMutation, UpdatePaymentCardMutationVariables>;

          

          export const useUpdatePaymentCardMutation = (options?:MutationHookOptions<UpdatePaymentCardMutation, UpdatePaymentCardMutationVariables>) => useMutation(UpdatePaymentCard, options);
          

          export type UpdatePaymentCardMutationOptions = MutationHookOptions<UpdatePaymentCardMutation, UpdatePaymentCardMutationVariables>;

          

          export type UpdatePaymentCardMutationResult = ReturnType<typeof useUpdatePaymentCardMutation>[1];

          
